import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewControlAlerta = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'wcpm_control_alerta',
        name: 'Control Alerta',
        component: ViewControlAlerta,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
